import { render } from "./OrderProducts.vue?vue&type=template&id=58ca0a97&scoped=true"
import script from "./OrderProducts.vue?vue&type=script&lang=js"
export * from "./OrderProducts.vue?vue&type=script&lang=js"

import "./OrderProducts.vue?vue&type=style&index=0&id=58ca0a97&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ca0a97"]])

export default __exports__